'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CoachHttpClientFactory = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _dec, _class;

var _aureliaFramework = require('aurelia-framework');

var _coach_browser_dom_gateway = require('../gateways/browser/coach_browser_dom_gateway');

var _coreEs = require('@mojility/core-es6');

var _settings = require('../settings');

var _settings2 = _interopRequireDefault(_settings);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CoachHttpClientFactory = exports.CoachHttpClientFactory = (_dec = (0, _aureliaFramework.inject)(_coreEs.Configuration, _coach_browser_dom_gateway.CoachBrowserDomGateway, _coreEs.BrowserLocationGateway), _dec(_class = function (_HttpClientFactory) {
  _inherits(CoachHttpClientFactory, _HttpClientFactory);

  function CoachHttpClientFactory(configuration, coachBrowserDomGateway, browserLocationGateway) {
    _classCallCheck(this, CoachHttpClientFactory);

    var _this = _possibleConstructorReturn(this, (CoachHttpClientFactory.__proto__ || Object.getPrototypeOf(CoachHttpClientFactory)).call(this, configuration));

    _this.browserDomGateway = coachBrowserDomGateway;
    _this.browserLocationGateway = browserLocationGateway;

    // Set up URL environments for the Coach apps
    _this.browserDomGateway.setGlobalValue(_coreEs.Configuration.EnvironmentsKey, _settings2.default);
    return _this;
  }

  _createClass(CoachHttpClientFactory, [{
    key: 'getPathPrefix',
    value: function getPathPrefix() {
      return '/api/v1/';
    }
  }, {
    key: 'buildBaseHeaders',
    value: function buildBaseHeaders() {
      var headers = _get(CoachHttpClientFactory.prototype.__proto__ || Object.getPrototypeOf(CoachHttpClientFactory.prototype), 'buildBaseHeaders', this).call(this);
      return Object.assign(headers, {
        'X-Coach-Source-Domain': this.browserLocationGateway.domainName,
        'X-Coach-Source-Port': this.browserLocationGateway.port
      });
    }
  }]);

  return CoachHttpClientFactory;
}(_coreEs.HttpClientFactory)) || _class);